// extracted by mini-css-extract-plugin
export default {"TagsContainer":"_TagsContainer--i418V","Tags":"_Tags--PB_iG","Responsive":"_Responsive--TynYJ"};